import { url } from "../../../url";
import { colorSelected } from "../actions";

const updateTodoColor = (todoId, color) => {
    return async (dispatch) => {
        const response = await fetch(`${url}/${todoId}`, {
            method: "PATCH",
            body: JSON.stringify({
                color: color,
            }),
            headers: { "Content-Type": "application/json; charset=utf-8" },
        });
        const todo = await response.json();

        dispatch(colorSelected(todo.id, todo.color));
    }
};

export default updateTodoColor;